import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import ClientDetail from "@/components/ClientDetail";
import { APP_LOGO, APP_NAME } from "@/lib/labels";

export default function ClientDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const goBack = () => navigate("/");

  return (
    <div className="min-h-screen bg-slate-50" data-testid="client-detail-page">
      <header className="border-b border-slate-200 bg-white sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-6 py-3 flex items-center gap-3">
          <button
            onClick={goBack}
            className="inline-flex items-center gap-1.5 px-3 py-2 border border-slate-900 text-xs font-bold uppercase tracking-wider btn-swap"
            data-testid="back-to-list-button"
          >
            <ArrowLeft size={14} weight="bold" />
            Volver
          </button>
          <div className="flex items-center gap-2 ml-2">
            <img src={APP_LOGO} alt={APP_NAME} className="w-20 h-20 object-contain" />
            <div className="font-display font-black text-base hidden sm:block">{APP_NAME}</div>
          </div>
          <div className="flex-1" />
        </div>
      </header>

      <div className="max-w-6xl mx-auto">
        <ClientDetail
          clientId={id}
          onUpdated={() => {}}
          onDeleted={() => navigate("/")}
          onDocChanged={() => {}}
        />
      </div>
    </div>
  );
}
